<template>
  <VModal ref="modal" @modal:hidden="$emit('closed')" disable-backdrop-click>
    <template #default>
      <div class="rounded shadow-xs w-full max-w-3xl mx-auto" @click.stop>
        <div class="rounded shadow-lg bg-white overflow-hidden">
          <div class="h-10 bg-white pl-4">
            <div class="flex items-center justify-between">
              <div class="flex-1">
                <h1 class="text-sm">Edit Note</h1>
              </div>
              <div class="flex-none">
                <button
                  class="h-10 w-10 inline-flex items-center justify-center hover:bg-gray-200 focus:outline-none"
                  @click="$refs.modal.close()"
                >
                  <svg viewBox="0 0 24 24" fill="currentColor" class="inline-flex w-5 h-5">
                    <path
                      d="M12 10.586l4.95-4.95 1.414 1.414-4.95
                      4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95
                      4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05
                      5.636z"
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
          <div class="p-12 bg-gray-100 space-y-6">
            <ValidationObserver slim v-slot="{ handleSubmit, invalid }" ref="observer">
              <NoteForm
                :content.sync="formData.content"
                :disabled="pending"
                :invalid="invalid"
                @submit="handleSubmit(submit)"
                @cancel="$refs.modal.close()"
              />
            </ValidationObserver>
          </div>
        </div>
      </div>
    </template>
  </VModal>
</template>

<script>
import NoteForm from '@/components/Notes/NoteForm.vue';
import veeValidateErrorsMixin from '@/mixins/veeValidateErrorsMixin';
import { HTTP_UNPROCESSABLE_ENTITY } from '@/api/http-response-codes';

export default {
  name: 'EditNoteModal',
  mixins: [veeValidateErrorsMixin],
  components: {
    NoteForm,
  },
  props: {
    noteId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      formData: {},
      pending: false,
    };
  },
  computed: {
    note() {
      return this.$store.state.entities.notes.byId[this.noteId];
    },
  },
  watch: {
    note({ content }) {
      this.formData = { content };
    },
  },
  created() {
    this.formData = {
      content: this.note?.content || '',
    };
  },
  methods: {
    async submit() {
      try {
        this.pending = true;
        await this.$store.dispatch({
          type: 'ui/notes/update',
          id: this.note.id,
          body: this.formData,
        });
      } catch (error) {
        if (error?.response?.status === HTTP_UNPROCESSABLE_ENTITY) {
          this.observer = this.$refs.observer;
          this.addServerErrors(error?.response?.data?.errors || {});
        }
      } finally {
        this.pending = false;
      }
    },
  },
};
</script>
